// storageUtils.js
const domain_key = "student_";

export const StorageService = {
  setItem(key, value) {
    try {
      localStorage.setItem(domain_key + key, JSON.stringify(value));
    } catch (error) {
      console.error("Storage set error:", error);
    }
  },

  getItem(key) {
    try {
      const item = localStorage.getItem(domain_key + key);
      if (!item || item === "undefined" || item === "null") {
        return null;
      }
      return JSON.parse(item);
    } catch (error) {
      console.error("Storage get error:", error);
      return null;
    }
  },

  removeItem(key) {
    try {
      localStorage.removeItem(domain_key + key);
    } catch (error) {
      console.error("Storage remove error:", error);
    }
  },

  clear() {
    try {
      Object.keys(localStorage)
        .filter((key) => key.startsWith(domain_key))
        .forEach((key) => localStorage.removeItem(key));
    } catch (error) {
      console.error("Storage clear error:", error);
    }
  },

  //   getStorageKey(key) {
  //     const { hostname, pathname } = window.location;
  //     const subdomain = pathname.split("/")[1]; // Assuming the subdomain is the first part of the pathname
  //     return `${subdomain}_${key}`;
  //   },
};
